module.exports = __webpack_public_path__ + "e2192f075b72863208d043fff9fc174f.svg";